module.exports = __webpack_public_path__ + "static/media/foto6.1f0f7ed6.jpeg";